module.exports = __webpack_public_path__ + "img/uefa-nations-league-1864__dark.dbae94cc.png";